<template>
  <el-select
    v-model="dataValue"
    style="width: 120px">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'CustomTopFlagSelect',
  props: {
    value: { type: Number, default: 1 }
  },
  data() {
    return {
      options: [{ label: '已上首页', value: 1 }, { label: '未上首页', value: 0 }]
    }
  },
  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
